import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import AddressSection from './components/AddressSection';
import GuideSection from './components/GuideSection';
import FeatureSection from './components/FeatureSection';
import FAQSection from './components/FAQSection';
import ArticlePreviewSection from './components/ArticlePreviewSection';
import { siteInfo } from '@/mocks/homepage';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: siteInfo.name,
      url: siteInfo.url,
      description: siteInfo.description,
      email: siteInfo.email,
      telephone: siteInfo.phone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: siteInfo.address,
        addressCountry: 'CN',
      },
      foundingYear: siteInfo.foundingYear,
    },
    {
      '@type': 'WebSite',
      name: siteInfo.fullName,
      url: siteInfo.url,
      description: siteInfo.description,
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteInfo.url}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: siteInfo.fullName,
      description: siteInfo.description,
      url: siteInfo.url,
      isPartOf: { '@type': 'WebSite', name: siteInfo.fullName, url: siteInfo.url },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '98堂入口地址无法访问怎么办？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '首先请确认您使用的是本页提供的最新官方地址。如仍无法访问，可尝试切换备用入口，或清除浏览器缓存后重试。若问题持续，建议检查本地网络设置或联系在线客服获取帮助。',
          },
        },
        {
          '@type': 'Question',
          name: '如何判断是否访问的是官方正版入口？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '请认准本页列出的官方域名地址。官方入口具备HTTPS安全证书，页面底部有完整的联系方式和备案信息。切勿通过搜索引擎广告或不明链接进入，以免误入仿冒网站。',
          },
        },
        {
          '@type': 'Question',
          name: '忘记账号密码如何找回？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '在登录页面点击"忘记密码"，按提示输入注册时使用的手机号或邮箱，系统将发送验证码。验证通过后即可重设密码。若注册信息已变更，请联系客服人工处理。',
          },
        },
        {
          '@type': 'Question',
          name: '98堂支持哪些设备和浏览器？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '98堂支持Windows、Mac、iOS、Android等主流操作系统，兼容Chrome、Safari、Edge、Firefox等现代浏览器。建议保持浏览器为最新版本以获得最佳体验。',
          },
        },
        {
          '@type': 'Question',
          name: '账户安全问题如何保障？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '98堂采用多重安全防护机制，包括SSL加密传输、登录异常监测、操作行为分析等。建议用户开启手机验证或二次验证，定期修改密码，不在公共设备上保存登录状态。',
          },
        },
        {
          '@type': 'Question',
          name: '收藏本页有什么好处？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '收藏本页后，您可以随时通过书签快速找到最新官方入口，无需担心地址变更或遗忘。本页将始终保持更新，是您访问98堂最可靠的导航站点。',
          },
        },
      ],
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: siteInfo.url },
      ],
    },
  ],
};

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageMeta schema={homeSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <AddressSection />
        <GuideSection />
        <FeatureSection />
        <FAQSection />
        <ArticlePreviewSection />
      </main>
      <Footer />
    </>
  );
}